import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from 'util/gtm';

const RouteScrollToTop = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Track page_view on every route change (skip initial render — handled by initGTM)
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      trackPageView(location.pathname + location.hash);
    }
  }, [location.pathname]);

  return null;
};

export default RouteScrollToTop;
